jQuery(document).ready(function() {


    // jQuery('.modlypop').each(function() {
    //     var $pop = jQuery(this);
    //     var showAfter = $pop.attr('data-showafter');
    //     var expiresAfter = $pop.attr('data-expiresafter');
    //     var modalRef = $pop.attr('data-pgmodal');
    
    //     if(Cookies.get('shownpop'+modalRef)) return;
     
    //     setTimeout(function() {
    //         $pop.fadeIn();
    //         if(expiresAfter == 'session') {
    //             Cookies.set('shownpop'+modalRef, '1');
    //         } else {
    //             Cookies.set('shownpop'+modalRef, '1', { expires: 30 })
    //         }
    //     }, showAfter * 1000);
    
    //     console.log(showAfter * 1000);
        
    // });


    jQuery('.modlypop .personpop-bg, .modlypop .exitblocker').on('click', function() {
        jQuery(this).closest('.modlypop').fadeOut();
    });


    // if(jQuery('.marquee').length) {
    //     jQuery('.marquee').each(function() {
    //         jQuery(this).marquee({
    //             //duration in milliseconds of the marquee
    //             duration: 30000,
    //             //gap in pixels between the tickers
    //             gap: 0,
    //             //time in milliseconds before the marquee will start animating
    //             delayBeforeStart: -30000,
    //             //'left' or 'right'
    //             direction: 'left',
    //             //true or false - should the marquee be duplicated to show an effect of continues flow
    //             duplicated: true
    //         });
    //     });
    // }
    
    jQuery('a.pingcardinner[href=""]').on('click',function(e) {
        e.preventDefault();
    });



    jQuery(".propscroller").click(function() {
        jQuery('html, body').animate({
            scrollTop: jQuery(this).closest('.hero-headerbit').next().offset().top
        }, 0);
    });

    jQuery('.btn-transparent-arrows').append('<svg xmlns="http://www.w3.org/2000/svg" width="16.809" height="11.988" viewBox="0 0 16.809 11.988"><g id="Group_4759" data-name="Group 4759" transform="translate(-1100.75 -1225.439)"><path id="Path_328" data-name="Path 328" d="M-16718.3-20603.133l4.934,4.936,4.934-4.936" transform="translate(21715.004 -15481.93) rotate(-90)" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><line id="Line_287" data-name="Line 287" x1="15.305" transform="translate(1101.5 1231.5)" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-width="1.5"/></g></svg>');


    jQuery('.full-slickslider').slick({
        arrows: true,
         infinite: true,
         speed: 750,
         centerMode: true,
        centerPadding: '212px',
        slidesToShow: 1,  
        responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                dots: true
              }
            }
        ]
    });

    jQuery('.newsfeedslide').slick({
        arrows: false,
         infinite: true,
         speed: 750,
         centerMode: true,
        slidesToShow: 3,  
        responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                arrows: false,
                dots: true
              }
            }
        ]
    });  


    jQuery('.sliderbits-rev').slick({
        arrows: false,
        infinite: true,
        centerMode: false,
        adaptiveHeight: true,
        slidesToShow: 4,  
        responsive: [
            {
              breakpoint: 768,
              settings: { 
                centerMode: false,
                slidesToShow: 1,
                arrows: false,
                dots: false
              }
            }
        ]
    });

    jQuery('.iconbitsmob').slick({
        dots: true,
        arrows: false,
         infinite: true,
         variableWidth: true,
         speed: 750,
         centerMode: true,
        centerPadding: '20px',
        slidesToShow: 1, 
    });

    jQuery('.teamslida').slick({
        dots: false,
        arrows: true,
         infinite: true,
         variableWidth: true,
         speed: 750,
         centerMode: true,
        centerPadding: '20px',
        slidesToShow: 1, 
    });

    jQuery('.testimslider').each(function() {
        var $thisTesti = jQuery(this);
        jQuery('.testimslider').slick({
            arrows: false,
            dots: true,
            infinite: true,
            speed: 750,
            centerMode: true,
            slidesToShow: 1, 
            appendDots:  $thisTesti.closest('.testimsliderwrap').find('.sliderarrowinsert')
        });
    });

    
    jQuery('.revvyslider').each(function() {
        var $thisTesti = jQuery(this);
        jQuery('.revvyslider').slick({
            arrows: false,
            dots: true,
            infinite: true,
            speed: 750,
            centerMode: false,
            slidesToShow: 1, 
            appendDots:  $thisTesti.closest('.revvywrap').find('.sliderarrowinsert')
        });
    });




    jQuery('.pinglist-slider').each(function() {
        var $thisTesti = jQuery(this);
        $thisTesti.slick({
            arrows: false,
            dots: true,
            infinite: true,
            speed: 750,
            appendDots:  $thisTesti.closest('.newsfeedkee').find('.sliderarrowinsert'),
            centerMode: false,
            slidesToShow: $thisTesti.attr('data-numslides'),  
            responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    arrows: false, 
                    dots: true
                  }
                }
            ]
        });
    });


    jQuery('.fullbleed-slider').slick({
        arrows: false,
        infinite: true,
        centerMode: false,
        adaptiveHeight: true,
        slidesToShow: 1
    });


    jQuery('.fullbleed-slider-box').each(function() {
        var $slidbox = jQuery(this);


        $slidbox.closest('.newsfeed-fullbleed').find('.sliderarrowinsert').addClass('rerwerw');

        jQuery(this).slick({
            arrows: false,
            infinite: true,
            centerMode: false,
            dots: true,
            adaptiveHeight: true,
            appendDots:  $slidbox.closest('.newsfeed-fullbleed').find('.sliderarrowinsert'),
            slidesToShow: 1
        });
    });



jQuery(window).on('load', function() {
    if (jQuery('div#sbi_images').length) {
        jQuery('div#sbi_images').slick({
            arrows: false,
            dots: true,
            infinite: true,
            speed: 750,
            appendDots: jQuery('div#sbi_images').closest('.feedblock').find('.sliderarrowinsert'),
            centerMode: false,
            slidesToShow: 4,
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    arrows: false,
                    dots: true
                }
            }]
        });
        jQuery(window).trigger('resize');
    }
});

    

    jQuery('.arr-right').on('click', function() {
        if(jQuery(this).closest('.slick-slider').length) jQuery(this).closest('.slick-slider').slick('next');
        if(jQuery(this).closest('.testimsliderwrap').find('.slick-slider').length) jQuery(this).closest('.testimsliderwrap').find('.slick-slider').slick('next');
        if(jQuery(this).closest('.longslider').find('.slick-slider').length) jQuery(this).closest('.longslider').find('.slick-slider').slick('next');
        if(jQuery(this).closest('.revvywrap').find('.slick-slider').length) jQuery(this).closest('.revvywrap').find('.slick-slider').slick('next');
        if(jQuery(this).closest('.newsfeedkee').find('.slick-slider').length) jQuery(this).closest('.newsfeedkee').find('.slick-slider').slick('next');
        if(jQuery(this).closest('.newsfeed').find('.slick-slider').length) jQuery(this).closest('.newsfeed').find('.slick-slider').slick('next');
        if(jQuery(this).closest('.newsfeed-fullbleed').find('.slick-slider').length) jQuery(this).closest('.newsfeed-fullbleed').find('.slick-slider').slick('next');
        if(jQuery(this).closest('.feedblock').find('.slick-slider').length) jQuery(this).closest('.feedblock').find('.slick-slider').slick('next');

    });
    
    jQuery('.arr-left').on('click', function() {
        if(jQuery(this).closest('.slick-slider').length) jQuery(this).closest('.slick-slider').slick('prev');
        if(jQuery(this).closest('.testimsliderwrap').find('.slick-slider').length) jQuery(this).closest('.testimsliderwrap').find('.slick-slider').slick('prev');
        if(jQuery(this).closest('.longslider').find('.slick-slider').length) jQuery(this).closest('.longslider').find('.slick-slider').slick('prev');
        if(jQuery(this).closest('.revvywrap').find('.slick-slider').length) jQuery(this).closest('.revvywrap').find('.slick-slider').slick('prev');
        if(jQuery(this).closest('.newsfeedkee').find('.slick-slider').length) jQuery(this).closest('.newsfeedkee').find('.slick-slider').slick('prev');
        if(jQuery(this).closest('.newsfeed').find('.slick-slider').length) jQuery(this).closest('.newsfeed').find('.slick-slider').slick('prev');
        if(jQuery(this).closest('.newsfeed-fullbleed').find('.slick-slider').length) jQuery(this).closest('.newsfeed-fullbleed').find('.slick-slider').slick('prev');
        if(jQuery(this).closest('.feedblock').find('.slick-slider').length) jQuery(this).closest('.feedblock').find('.slick-slider').slick('prev');


        
    });


    jQuery('.head-accord-bit').on('click', function() {
        if(jQuery(this).closest('.the-accord').is('.accord-active')) {
            jQuery(this).closest('.the-accord').removeClass('accord-active');
            jQuery(this).closest('.the-accord').find('.body-accord').css('max-height', 0);
        } else {
            jQuery(this).closest('.the-accord').addClass('accord-active');
            jQuery(this).closest('.the-accord').find('.body-accord').css('max-height', jQuery(this).closest('.the-accord').find('.body-accord-inner').outerHeight());
        }
    });


    jQuery('.tabby').on('click', function() {
        var $parent = jQuery(this).closest('.tabberwrap');
        var trget = jQuery(this).attr('data-tabtrigger');
        
        $parent.find('.tabbyactive').removeClass('tabbyactive');
        $parent.find('.tabby[data-tabtrigger="'+trget+'"]').addClass('tabbyactive');
        $parent.find('.tabby-body[data-tabbody="'+trget+'"]').addClass('tabbyactive');
    });

    jQuery('.stickitem').stick_in_parent({
        offset_top: jQuery('#wrapper-navbar').outerHeight()+ 10
        //offset_top: (jQuery(window).height() / 2) - (jQuery('.stickitem').outerHeight() / 2)
    });

});

function updateRelativeHeightBits() {
    jQuery('.image-text-block.bleed-1 .connoimg').each(function() {
        jQuery(this).parent().css('height', jQuery(this).outerHeight());
    });
}

function disableScrolling(){
    var x=window.scrollX;
    var y=window.scrollY;
    window.onscroll=function(){window.scrollTo(x, y);};
}

function enableScrolling(){
    window.onscroll=function(){};
}


jQuery(document).ready(function() {
    updateRelativeHeightBits();
});

jQuery(window).resize(function() {
    updateRelativeHeightBits();
});

jQuery('.playico').on('click', function() { 
    jQuery(this).closest('.image-text-block').find('.fkmodal').fadeIn();
    jQuery(this).closest('.vidembed').find('.fkmodal').fadeIn();
    jQuery(this).closest('.vidembed').find('.fkmodal').find('.vjs-big-play-button').click();
    jQuery(this).closest('.image-text-block').find('.fkmodal').find('.vjs-big-play-button').click();
    enableScrolling();
});

jQuery(document).ready(function() {
    if(jQuery('.catblock').length) {
        jQuery('.catblock').selectric();
    }

    
});

jQuery('.ginput_container_fileupload').each(function() {
    jQuery('<div class="thefkinput"><span class="placeholda">ATTACH FILE</span> <div class="thefloaticon"><div class="floatclip"></div></div></div>').insertAfter(jQuery(this).find('input[type="file"]'));
});


jQuery('.ginput_container_fileupload input[type="file"]').bind('change', function() {
    jQuery(this).closest('.ginput_container_fileupload').find(".thefkinput span").html(jQuery(this).val());
    jQuery(this).closest('.ginput_container_fileupload').find(".placeholda").removeClass('placeholda');
});

jQuery('.fkmodal-cross').on('click', function() {
    jQuery(this).closest('.fkmodal').fadeOut();

    if(jQuery(this).closest('.fkmodal').find('video').length) jQuery(this).closest('.fkmodal').find('video').trigger('pause');
    enableScrolling();
});

jQuery('.list-toggler li').on('click', function() {
    var cTarget = jQuery(this).attr('data-listkey');
    jQuery(this).closest('.listandtext').find('.list-toggler .listactive').removeClass('listactive');
    jQuery(this).closest('.listandtext').find('.conto-tab.listactive').removeClass('listactive');
    jQuery(this).closest('.listandtext').find('div[data-listarget="'+cTarget+'"]').addClass('listactive');
    jQuery(this).closest('.listandtext').find('.list-toggler li[data-listkey="'+cTarget+'"]').addClass('listactive');
});



function alignNav() {
    if(!jQuery('.navvy-fixed').length) return false;
    jQuery('body').css('padding-top', jQuery('.navvy-fixed').outerHeight());
}

jQuery(document).ready(function() {
    alignNav();
});
jQuery(window).resize(function() {
    alignNav();
});

jQuery('.cookiebar-inner .btn').on('click', function(e) {
    e.preventDefault();
    Cookies.set('cookies_accepted', '1', { expires: 30 })
    jQuery('.cookiebar').addClass('cookies-hidden');
});

jQuery(document).ready(function() {
    if(!Cookies.get('cookies_accepted')) {
        jQuery('.cookies-hidden').removeClass('cookies-hidden');
    }
});

jQuery('.searchicon a').on('click', function(e) {
    e.preventDefault();
    jQuery('.searchformhead').toggleClass('searchformhead-hidden');
});


jQuery('#main-menu li, #main-menu ul').on('mouseover mouseout', function() {
    var allDroppers = jQuery('.dropdown-menu:visible');

    jQuery('.fotype').removeClass('fotype');
    jQuery('.latype').removeClass('latype');

    allDroppers.css('height', false);

    var maxHeight = -1;
    var len = allDroppers.length;
    allDroppers.each(function(index) {
        if (index === (len - 1)) jQuery(this).addClass('latype');
        if (index === 0) jQuery(this).addClass('fotype');
        maxHeight = maxHeight > jQuery(this).height() ? maxHeight : jQuery(this).height();
    });

    allDroppers.css('height', maxHeight);
    
});

jQuery('.menu-item-has-children.dropdown>a').append('<div class="chevva"><svg xmlns="http://www.w3.org/2000/svg" width="6.404" height="11.308" viewBox="0 0 6.404 11.308"><path id="Path_14684" data-name="Path 14684" d="M0,4.594,4.594,0,9.186,4.594" transform="translate(5.654 1.061) rotate(90)" fill="none" stroke="#3b3c4b" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/></svg></div>');


jQuery('.trigpopperup').on('click', function() {
    var $cParent = jQuery(this).closest('.longslider');
    var thisTarget = jQuery(this).attr('data-fkpoptrg');
    $cParent.find('.fkreviewpop[data-fkpopid="'+thisTarget+'"]').fadeIn();    
});

jQuery('.fkreviewpop .exitblocker, .fkreviewpop .personpop-bg').on('click', function() {
      jQuery(this).closest('.fkreviewpop').fadeOut();
});


jQuery('.personimgbit').on('click', function() {
    jQuery('.personpop-modal[data-tid="'+jQuery(this).attr('data-trgimg')+'"]').fadeIn();
});

jQuery('.exitblocker').on('click', function() {
    jQuery('.personpop-modal').fadeOut();
});


jQuery(document).ready(function() {
    jQuery('body').attr('data-scrollpos', jQuery(window).scrollTop());
});

jQuery(window).scroll(function (event) {
    jQuery('body').attr('data-scrollpos', jQuery(window).scrollTop());
});

jQuery('.subbtn').on('click', function(e) {
    e.preventDefault();
    jQuery(this).closest('form').find('input[type="submit"]').click();
});

jQuery('.catblock').on('change', function() {
    jQuery(this).closest('form').submit();
});



jQuery(window).on('load', function() {


    if(jQuery('.masonwrap').length) {
        jQuery('.masonwrap').each(function() {
            var $mason = jQuery(this).masonry({
                isInitLayout: false,
                itemSelector: '.masonry-galleryimgbit'
            });
            $mason.masonry( 'on', 'layoutComplete', function() {
                AOS.refresh();
            });
            $mason.masonry();
        });
    }
});


// var outerContainerSize = 0;
// outerContainerSize = (jQuery(window).width() - jQuery('.container')[0].getBoundingClientRect().width) / 2;


// jQuery(window).resize(function() {
//     outerContainerSize = (jQuery(window).width() - jQuery('.container')[0].getBoundingClientRect().width) / 2;
//     jQuery('.bleed-1:not(.imgdirection-flex-row) .connoimg').css('left', -outerContainerSize);
//     jQuery('.bleed-1.imgdirection-flex-row .connoimg').css('right', -outerContainerSize);
// });
 
// jQuery('.bleed-1:not(.imgdirection-flex-row) .connoimg').css('left', -outerContainerSize);
// jQuery('.bleed-1.imgdirection-flex-row .connoimg').css('right', -outerContainerSize);

// console.log(outerContainerSize);



var scrollOffset = 100;

jQuery(window).scroll(function() {


    

  jQuery('.longslider').each(function() {
      //console.log(this+$(this).position().top);
    if (jQuery(window).scrollTop() > jQuery(this).position().top + (scrollOffset - jQuery(this).height())) {
      if (!jQuery(this).hasClass('wpb_start_animation')){
        jQuery(this).addClass('wpb_start_animation');
      }
    }
  });
});


jQuery('div[data-fklink]').on('click', function() {
    if(jQuery(this).attr('data-fklink')) {
        window.location.href = jQuery(this).attr('data-fklink');
    }
});


 
jQuery('.dotsbit button[data-target]').on('click', function(e) {
    e.preventDefault();
    jQuery(this).closest('.slick-slider').slick('slickGoTo', jQuery(this).attr('data-target'));
});


function updatePad() {


    if(!jQuery('body.disablestickynav-1 header#wrapper-navbar').length) return;
    
    var NavHeight = jQuery('body.disablestickynav-1 header#wrapper-navbar').outerHeight();

    jQuery('.hero-headerbit').css('padding-top', NavHeight);
    jQuery('.hero-headerbit').css('padding-bottom', NavHeight);
}

updatePad();

jQuery(window).on('resize', function() {
    updatePad();
});

// Import necessary libraries
import Swiper from 'swiper/bundle';
import GLightbox from "glightbox";
import AOS from 'aos';
import { gsap } from "gsap";
import { ScrollTrigger, ScrollSmoother, SplitText } from "gsap/all";

// Register GSAP plugins
gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);

class Base {
  constructor() {
    this.documentReady();
    this.windowLoad();
  }

  documentReady() {
    $(document).ready(() => {
      console.log('Document ready!');
      this.setupScrollSmoother();
      AOS.init();
      this.setupAnimations();
      this.setupFadeUpItems();
      this.setupAccordion();
      this.setupHeaderScroll();
      this.setupMobileMenu();
      this.setupExternalLinks();
      this.setBreaklines();
      this.valuesCarousel();
      this.twoColumnCTA();
      this.partnersCarousel();
      this.setupLightbox();

      if (!$('.cta-banner:last-child').length) {
        $('.site-footer').addClass('smaller-footer');
      }
    });
  }

  windowLoad() {
    $(window).on('load', () => console.log('Document loaded!'));
    $('.personpop-modal').appendTo('.site-wrapper');

    setTimeout(() => {
      this.locationsCarousel();
      $('.personpop-modal').appendTo('.site-wrapper');
    }, 500);
    

    if(window.innerWidth > 1024){

      // Example using a hypothetical API or callback to get scroll position
      $(document).mousemove(function(e) {
        // Variables to store mouse position
        var mouseX = e.pageX;
        var mouseY = e.pageY;
    
        // Assume the movement is for all .circle elements for demonstration
        $('.btn .circle').each(function() {
            var $circle = $(this);
            var $btn = $circle.closest('.btn');
    
            // Get the offset of the parent .btn
            var btnOffset = $btn.offset();
            
            // Calculate the position relative to the .btn
            var circleLeft = mouseX - btnOffset.left;
            var circleTop = mouseY - btnOffset.top;
    
            // Apply the calculated position to the .circle
            $circle.css({
                'left': circleLeft + 'px',
                'top': circleTop + 'px',
            });
        });
      });
      
      // Iterate over each .round-animation-container
      $('.round-animation-container.left').each(function() {
        // Using jQuery to get the current container and its data-color attribute
        var $container = $(this);
        var colorScheme = $container.data('colour');
        
        // Select the SVG and paths within this specific container
        var $svg = $container.find('svg');
        var $paths = $svg.find('path');
        
        // Initialize the GSAP timeline for this container with ScrollTrigger
        var tl = gsap.timeline({
          scrollTrigger: {
            trigger: $container[0], // Direct DOM node reference
            start: "top bottom",
            end: "bottom top",
            scrub: true,
          }
        });
      
        // Define initial and final colors based on the data-color attribute
        var initialColor, finalColor;
        if (colorScheme === 'purple') {
          initialColor = "#9063CD"; // Starting color for purple scheme
          finalColor = "#F4364C"; // Ending color for purple scheme
        } else if (colorScheme === 'white') {
          initialColor = "#E4E4E466"; // Starting color for white scheme
          finalColor = "#E4E4E4E5"; // Ending color for white scheme
        }

        $paths.css('fill', initialColor);
      
        // Apply the animation to the paths
        tl.to($paths.toArray(), { // Convert jQuery object to an array for GSAP
          fill: initialColor,
          duration: 2 // Adjust this duration as needed
        }, 0)
        .to($paths.toArray(), { // Ensure the final color transition applies correctly
          fill: finalColor,
          duration: 6 // Adjust this duration as needed
        }, "100%");
      
        // Apply the rotation to the entire SVG
        tl.to($svg[0], { // Direct DOM node reference for GSAP
          rotation: 50,
          duration: 8,
          transformOrigin: "center"
        }, 0);
      });

      $('.round-animation-container.right').each(function() {
        // Using jQuery to get the current container and its data-color attribute
        var $container = $(this);
        var colorScheme = $container.data('colour');
        
        // Select the SVG and paths within this specific container
        var $svg = $container.find('svg');
        var $paths = $svg.find('path');
        
        // Initialize the GSAP timeline for this container with ScrollTrigger
        var tl = gsap.timeline({
          scrollTrigger: {
            trigger: $container[0], // Direct DOM node reference
            start: "top bottom",
            end: "bottom top",
            scrub: true,
          }
        });
      
        // Define initial and final colors based on the data-color attribute
        var initialColor, finalColor;
        if (colorScheme === 'purple') {
          initialColor = "#9063CD"; // Starting color for purple scheme
          finalColor = "#F4364C"; // Ending color for purple scheme
        } else if (colorScheme === 'white') {
          initialColor = "#E4E4E466"; // Starting color for white scheme
          finalColor = "#E4E4E4E5"; // Ending color for white scheme
        }

        $paths.css('fill', initialColor);
      
        // Apply the animation to the paths
        tl.to($paths.toArray(), { // Convert jQuery object to an array for GSAP
          fill: initialColor,
          duration: 2 // Adjust this duration as needed
        }, 0)
        .to($paths.toArray(), { // Ensure the final color transition applies correctly
          fill: finalColor,
          duration: 6 // Adjust this duration as needed
        }, "100%");
      
        // Apply the rotation to the entire SVG
        tl.to($svg[0], { // Direct DOM node reference for GSAP
          rotation: -50,
          duration: 8,
          transformOrigin: "center"
        }, 0);
      });
    }
  }

  setupScrollSmoother() {
    if (window.innerWidth > 100) {
      const smoother = ScrollSmoother.create({
        smooth: 1.2,
        effects: true,
        smoothTouch: false,
        smoothing: 0.8,
      });

      this.setupAnchorLinks(smoother);
    }
  }

  setupAnchorLinks(smoother) {
    document.querySelectorAll('.anchor-link, a[href*="#"]').forEach(link => {
      link.addEventListener('click', e => this.handleAnchorLinkClick(e, link, smoother));
    });
  }

  handleAnchorLinkClick(e, link, smoother) {
    e.preventDefault();
    const href = link.getAttribute('href');

    if(href){
      var target = href.startsWith('#') ? href : href.split('#')[1];
      target = $(target);
    }else{
      var target = $(link).closest('section').innerHeight();
    }

    if (target) smoother.scrollTo(target, true, "top top");
  }

  setupLightbox() {
    GLightbox({
      touchNavigation: true,
      loop: true,
      autoplayVideos: true,
    });
  }

  setupAnimations() {
    document.querySelectorAll(".animate-title").forEach(quote => {
      new SplitText(quote, {
        type: "lines, words",
        linesClass: "split-line",
        wordsClass: 'split-word'
      });

      gsap.from(quote.querySelectorAll(".split-word"), {
        duration: 0.8,
        ease: "circ.out",
        y: 80,
        opacity: 0,
        stagger: 0.05,
        scrollTrigger: {
          trigger: quote,
          start: "top 90%",
          toggleActions: "restart pause resume pause",
        }
      });
    });
  }

  setupFadeUpItems() {
    const fadeUpItems = gsap.utils.toArray('.fadeUp, p, .copy li, h1, h2, h3, h4, h5');
    gsap.set(fadeUpItems, {
      opacity: 0,
      y: 20,
    });
    fadeUpItems.forEach(item => {
      gsap.to(item, {
        opacity: 1,
        y: 0,
        duration: .7,
        scrollTrigger: {
          trigger: item,
          start: "top 90%",
        }
      })
    });
  }

  setupAccordion() {
    $(document).on('click', ".accordion-header", function () {
      var clickedAccordion = $(this).parents(".single-accordion-item");
      var accordionId = clickedAccordion.attr("accordion-id");
      var activeAccordion = $(".single-accordion-item.active");
    
      activeAccordion.find(".accordion-content").stop().slideToggle().end().add(".single-accordion-item.active").removeClass("active");
    
      if (activeAccordion.attr("accordion-id") !== accordionId) {
        clickedAccordion.addClass("active").find(".accordion-content").stop().slideToggle();
        $(".faqs .accordion-image-container[accordion-id=" + accordionId + "]").addClass("active");
      }
      var next = $(`.right-img[accordion-id="${accordionId}"]`);
      var active = $(".right-img.active");
      console.log(next);

      if($(next).length && $(active).attr('accordion-id') != accordionId){

        $(active).addClass("fade-out-hidden");
        $(next).addClass("fade-out-hidden");

        setTimeout(function () {
            $(next).addClass("active");
            $(active).removeClass("active");
            setTimeout(function () {
            $(next).removeClass("fade-out-hidden");
            $(active).removeClass("fade-out-hidden");
            }, 100);
        }, 500);
      }
    });
  }

  setupHeaderScroll() {
    let lastScrollTop = 0;
    $(window).scroll(() => {
      let st = $(window).scrollTop();
      if (st > lastScrollTop) {
        // Downscroll code
        $(".site-header").addClass("scrolling").removeClass("up");
      } else {
        // Upscroll code
        $(".site-header").addClass("up");
        if (st < 150) $(".site-header").removeClass("scrolling");
      }
      lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    });
  }

  setupMobileMenu() {
    $('.hamburger').on('click', function() {
      $('header').toggleClass('mobile-menu');
      $('html').toggleClass('html-overflow-hidden');
      $('.hamburger').toggleClass('active');
      $('.site-header__navigation').toggleClass('active');
      $('.megamenu').removeClass('active');
    });

    $(".site-header__navigation .menu-item-has-children > a").on("click", function (e) {
      if(window.innerWidth < 1025){
        e.preventDefault();

        $(this).parent().find('.megamenu').addClass('active');
      }
    });

    $('.back-button').on('click', function(){
      $('.megamenu').removeClass('active');
    }); 
  }

  setupExternalLinks() {
    $('.site-footer').on('click', 'a', function(event) {
      const href = $(this).attr('href');
      if (href.startsWith('http') && !href.includes(window.location.hostname)) {
        event.preventDefault();
        window.open(href, '_blank');
      }
    });
  }

  setBreaklines(){
    $('h1, h2, h3, h4, h5, h6').each(function() {
      // Get the current HTML of the heading
      var html = $(this).html();
  
      // Check if the heading contains '<br>' as text (not as HTML tag)
      if(html.indexOf('&lt;br&gt;') !== -1) {
          // Replace '<br>' text with an actual HTML <br> element
          var newHtml = html.replace(/&lt;br&gt;/g, '<br>');
  
          // Set the modified HTML back to the heading
          console.log(html);
          $(this).html(newHtml);
      }
    }); 
  }

  twoColumnCTA(){
    $('.two-column-cta .cta-container').hover(
      function() {
          $('.two-column-cta .cta-container').removeClass('hovered'); // Remove from all first
          $(this).addClass('hovered'); // Then add to this one
      }, 
      function() {
          $('.two-column-cta .cta-container').removeClass('hovered'); // Remove from this one
      }
    );
  }

  locationsCarousel() {
    // Check window width and set loop and centeredSlides options based on it
    var isAbove830 = window.innerWidth > 830;
    
    var swiper = new Swiper('.locations-carousel-container', {
      speed: 900, // 900ms transition speed
      slidesPerView: 1.1,
      spaceBetween: 34,
      loop: isAbove830, // Set to true only if window width is above 830px
      centeredSlides: isAbove830, // Set to true only if window width is above 830px
      loopAdditionalSlides: 3,
      pagination: {
        el: '.locations-carousel .swiper-pagination',
        type: 'progressbar'
      },
      navigation: {
          prevEl: '.locations-carousel .swiper-left',
          nextEl: '.locations-carousel .swiper-right',
      },
      breakpoints: {
          500: {
              slidesPerView: 1.4,
              spaceBetween: 25,
          },
          700: {
              slidesPerView: 1.2,
              spaceBetween: 25,
          },
          1025: {
              slidesPerView:1.3,
              spaceBetween: 24,
          },
          1300: {
              slidesPerView: 1.43,
              spaceBetween: 34,
          },
      },
    });

    swiper.loopDestroy();
    swiper.loopCreate();
  }

  partnersCarousel() {
    // Check window width and set loop and centeredSlides options based on it
    
    var swiper = new Swiper('.partners-carousel-container', {
      speed: 900, // 900ms transition speed
      slidesPerView: 'auto',
      spaceBetween: 22,
      watchOverflow: true,
      navigation: {
          prevEl: '.partners-carousel .swiper-left',
          nextEl: '.partners-carousel .swiper-right',
      },
      pagination: {
        el: '.partners-carousel .swiper-pagination',
        type: 'progressbar'
      },
      breakpoints: {
          500: {
              spaceBetween: 40,
          },
          700: {
              spaceBetween: 50,
          },
          1025: {
              spaceBetween: 60,
          },
          1300: {
              spaceBetween: 80,
          },
      },
    });
  }

  valuesCarousel(){
    if(window.innerWidth > 768){
      // Custom function to handle navigation with adjusted speed and immediate stopping
      function customSwiperNavigation() {
        const originalSpeed = 9000; // Original speed for autoplay and transitions
        const navigationSpeed = 900; // Speed for manual navigation transitions
    
        // Function to handle navigation with smooth transitions
        function navigateSwiper(direction) {
            swiper.autoplay.stop(); // Stop autoplay without affecting the swiper's state
    
            // Temporarily change the transition speed for a smoother manual navigation
            swiper.params.speed = navigationSpeed;
            swiper.setTransition(navigationSpeed);
    
            // Calculate the target index for navigation
            let targetIndex = swiper.activeIndex + (direction === 'next' ? 1 : -1);
    
            // Adjust for looping
            if (targetIndex >= swiper.slides.length) {
                targetIndex = 0; // Loop to the first slide
            } else if (targetIndex < 0) {
                targetIndex = swiper.slides.length - 1; // Loop to the last slide
            }
    
            // Ensure the transition is smooth by setting the swiper's slide to the target index
            swiper.slideTo(targetIndex, navigationSpeed);
    
            // Wait for the transition to complete before resetting the speed and restarting autoplay
            setTimeout(() => {
                swiper.params.speed = originalSpeed; // Reset speed to original
                swiper.setTransition(originalSpeed); // Apply original transition speed
                swiper.autoplay.start(); // Restart autoplay
            }, 3000);
        }
    
        // Attach click event listeners to navigation buttons
        $('.values-carousel .swiper-right').on('click', function() {
            navigateSwiper('next');
        });
    
        $('.values-carousel .swiper-left').on('click', function() {
            navigateSwiper('prev');
        });
      }

      if($('.values-carousel').length){
        var swiper = new Swiper('.values-carousel-container', {
          speed: 9000, // 900ms transition speed
          slidesPerView: 1.05,
          spaceBetween: 12,
          loop: true,
          centeredSlides: true,
          autoplay: {
            delay: 0,
            // pauseOnMouseEnter: true,
            disableOnInteraction: false,
          },
          waitForTransition: false,
          navigation: {
              prevEl: '.values-carousel .swiper-left',
              nextEl: '.values-carousel .swiper-right',
          },
          pagination: {
            el: '.values-carousel .swiper-pagination',
            type: 'progressbar'
          },
          breakpoints: {
              500: {
                  slidesPerView: 1.4,
                  spaceBetween: 15,
              },
              700: {
                  slidesPerView: 2.2,
                  spaceBetween: 20,
              },
              1025: {
                  slidesPerView:2.9,
                  spaceBetween: 20,
              },
              1300: {
                  slidesPerView: 3.7,
                  spaceBetween: 24,
              },
          }
        });

        customSwiperNavigation();

        $(swiper.wrapperEl).hover(function() {
          // Stop autoplay
          swiper.autoplay.stop();
      
          // Immediately stop the swiper's transition and "freeze" its position
          let currentTranslate = swiper.getTranslate(); // Get current translate position
          swiper.setTranslate(currentTranslate); // Apply the translate position to "freeze" it
      
          // Disable transition to avoid any ongoing animation effects
          swiper.wrapperEl.style.transition = "0s";
      
        }, function() {
          // Re-enable transition with the original speed
          swiper.wrapperEl.style.transition = "";
          swiper.params.speed = 9000; // Ensure the originalSpeed variable is defined with the swiper's speed
      
          // Optionally, you might want to adjust the swiper's position slightly if it's stuck between slides
          swiper.slideTo(swiper.activeIndex);
      
          // Restart autoplay
          swiper.autoplay.start();
          swiper.update();
        });
      }
    }else{
      var swiper = new Swiper('.values-carousel-container', {
        speed: 900, // 900ms transition speed
        slidesPerView: 1.05,
        spaceBetween: 12,
        loop: false,
        waitForTransition: false,
        pagination: {
          el: '.values-carousel .swiper-pagination',
          type: 'progressbar'
        },
        breakpoints: {
            500: {
                slidesPerView: 1.4,
                spaceBetween: 25,
            },
            700: {
                slidesPerView: 2.2,
                spaceBetween: 25,
            },
            1025: {
                slidesPerView:2.9,
                spaceBetween: 24,
            },
            1300: {
                slidesPerView: 3.7,
                spaceBetween: 24,
            },
        }
      });
    }
  }
}

new Base();
